import type * as React from 'react';
import { put } from '@Domain/Api';
import type { BeneficiaryContactPayload } from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactsFetched';
import beneficiaryContactUpdated, {
	type BeneficiaryContactUpdatedAction,
} from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactUpdated';
import beneficiaryContactUpdateFailed, {
	type BeneficiaryContactUpdateFailedAction,
} from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactUpdateFailed';
import type UpdateBeneficiaryContact from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Commands/UpdateBeneficiaryContact';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = BeneficiaryContactUpdatedAction | BeneficiaryContactUpdateFailedAction;

export default (command: UpdateBeneficiaryContact) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<BeneficiaryContactPayload>(
				`${parameters.api.host}/api/facilities/${command.facilityId}/beneficiaries/${command.beneficiaryId}/contacts/${command.contactId}`,
				command.toJSON(),
			);

			const action = beneficiaryContactUpdated(payload, command.beneficiaryId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryContactUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
